export const apiBaseUrl = "https://us-central1-aroundu-monitor.cloudfunctions.net/";
export const businessUploadDocumentMakeAPI =
  "https://hook.us1.make.com/nxewxgzi3lx7ywk44myo7me6qq9216mi";
